import { DocumentsCommandActions } from '@contexts/IdentityValidation/domain/ports/documents-command-actions.port';
import { DocumentsQueryActions } from '@contexts/IdentityValidation/domain/ports/documents-query-actions.port';
import { createContext, useContext } from 'react';

import { GqlDocumentsCommandActions } from '../gql/adapters/gql-documents-command.actions.adapter';
import { GqlDocumentsQueryActions } from '../gql/adapters/gql-documents-query.actions.adapter';

type DocumentsActionContextT = {
  documentQueryActions: DocumentsQueryActions;
  documentsCommandActions: DocumentsCommandActions;
};

export const documentsDefaultValue: DocumentsActionContextT = {
  documentsCommandActions: GqlDocumentsCommandActions,
  documentQueryActions: GqlDocumentsQueryActions,
};

export const documentActionsContext = createContext<DocumentsActionContextT>(documentsDefaultValue);

export const useDocumentActions = (): DocumentsActionContextT => useContext(documentActionsContext);
